import { render, staticRenderFns } from "./VistaRegistroComisiones.vue?vue&type=template&id=4201d37c"
import script from "./VistaRegistroComisiones.vue?vue&type=script&lang=js"
export * from "./VistaRegistroComisiones.vue?vue&type=script&lang=js"
import style0 from "./VistaRegistroComisiones.vue?vue&type=style&index=0&id=4201d37c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports